@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="apply-form-main mb-4">
    <div class="row mt-3 m-0 p-0">
      <div class="col-12">
        <div class="create-form pt-3 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="mb-3">
            <h5>Add Events</h5>
          </div>

          <form name="empForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="col-12 event-image p-0 mb-4 mr-3">
              @if (selectedImage || apidata) {
                <img [src]="selectedImage || eventNamePath" alt="Selected Image" />
              }

              @if (!selectedImage && !apidata) {
                <img [src]="imageUrl" alt="Default Image" />
              }

              <div class="choose_image">
                <input type="file" name="event_image" accept="image/*" id="event_image" [src]="selectedImage"
                  class="file btnPointer" (change)="onFileChange($event)" #event_image_input hidden required />
                  <input type="hidden" name="event_image" [(ngModel)]="imagePath" id="event_image" required />

                  <button type="button" (click)="triggerFileInput()" class="file-button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
              </div>


              <div class="media row text-secondary-light">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" name="event_name" class="form-control"
                      placeholder="Enter Event Name*"
                      [(ngModel)]="eventName" required />


                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input id="event_date" type="text" name="event_date"
                        class="form-control" placeholder="Enter Event Date*" onfocus="(this.type='date')"

                        onblur="(this.type= this.value ? 'date' : 'text')" [(ngModel)]="eventDate" required />

                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <input type="text" name="event_location" class="form-control"
                          placeholder="Enter Event Location*" [(ngModel)]="eventLocation" required />

                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <select name="event_type" class="dropdown-toggle checks-dropdown form-control selectpicker" [(ngModel)]="eventType" required>
                            <option value="" disabled selected>Event Type</option>
                            <option value="sports_activity">Sports Activities</option>
                            <option value="mind_activity">Mind Activities</option>
                            <option value="fun_activity">Fun Activities</option>
                            <option value="adventures_activity">
                              Adventures Activities
                            </option>
                          </select>

                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group description_area">
                          <textarea class="form-control pl-" name="event_detail"  ngModel
                            #event_detail="ngModel" placeholder="Event Description*" (input)="trimText()"
                          [(ngModel)]="eventDetail" required></textarea>
                          @if (
                            event_detail.valid &&
                            (event_detail.dirty || event_detail.touched)
                            ) {
                            <div>
                              @if (eventDetail.trim().length < 150) {
                                <p class="alert alert-warning">
                                  Ensure that the entered <strong>Description</strong> contains
                                  a minimum of 150 characters.
                                </p>
                              }
                            </div>
                          }
                        </div>
                      </div>

                      <div class="media col-12 row text-secondary-light time-detail pr-0 mb-1">
                        <div class="col-2 buttons pr-0">
                          <div class="form-group">
                            <!-- <button type="button" (click)="onCancel(f)" class="btn cancel"> -->
                            <button type="button" (click)="goToEventManagement()" class="btn cancel">Cancel</button>
                          </div>
                        </div>
                        @if (!apidata  || apidata.length === 0) {
                          <div class="col-2 buttons pr-0">
                            <button type="submit" class="btn apply" [disabled]="!f.valid || eventDetail.length < 150">
                              Add
                            </button>
                          </div>
                        }
                        @if (apidata) {
                          <div class="col-2 buttons pr-0">
                            <button type="submit" class="btn btn-primary btn edit">
                              Update
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>